import { render, staticRenderFns } from "./TrainingListClient.vue?vue&type=template&id=023dcc6e&scoped=true"
import script from "./TrainingListClient.vue?vue&type=script&lang=js"
export * from "./TrainingListClient.vue?vue&type=script&lang=js"
import style0 from "./TrainingListClient.vue?vue&type=style&index=0&id=023dcc6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023dcc6e",
  null
  
)

export default component.exports